import { render, staticRenderFns } from "./Mine.vue?vue&type=template&id=bab8c656&scoped=true"
import script from "./Mine.vue?vue&type=script&lang=js"
export * from "./Mine.vue?vue&type=script&lang=js"
import style0 from "./Mine.vue?vue&type=style&index=0&id=bab8c656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab8c656",
  null
  
)

export default component.exports